import { action } from 'easy-peasy';
import { IActionRemoveCarePlanMedicalNote } from '../types';

const removeCarePlanMedicalNote: IActionRemoveCarePlanMedicalNote = action((state, id) => {
  state.items = state.items.filter(item => item.id !== id);
});

export default removeCarePlanMedicalNote;
